import Modal from "@components/atoms/Modal";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import PDPScreen from "@scenes/pdp/PDPScreen";
import { Props } from "@scenes/pdp/types";
import { useTranslation } from "react-i18next";
import { Dimensions, View, Platform } from "react-native";
import { useTheme } from "styled-components/native";

const PDPModal = ({ route, isOpen, onClose }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const windowHeight = Dimensions.get("window").height;
  const { deviceWidth: windowWidth } = useIsFoldable();

  const isFromComponent = route?.params?.fromComponent === true;
  const isWeb = Platform.OS === "web" && !theme.isMobile && !theme.isTablet;
  const isWebTablet = Platform.OS === "web" && theme.isTablet;
  const modalType = isFromComponent && isWeb ? "popUp" : "sheet";
  const modalSize = modalType === "popUp" ? windowWidth * 0.8 : undefined;
  const webHeight =
    isFromComponent && isWeb
      ? Math.max(windowHeight * 0.8, 760)
      : isWebTablet
      ? windowHeight * 0.9
      : "auto";

  const containerWidth =
    modalType === "popUp" && modalSize ? modalSize : windowWidth;
  const containerHeight =
    isFromComponent && isWeb
      ? Math.max(windowHeight * 0.8, 760)
      : windowHeight * 0.9;

  const pdpScreenRoute = {
    ...route,
    isModal: true,
    fromReviewPage: true,
    params: {
      ...route?.params,
      containerWidth,
      containerHeight,
    },
  };

  return (
    <Modal
      type={modalType}
      size={modalSize}
      isOpen={isOpen}
      onClose={onClose}
      headerTitle={t("pdp.modalTitle.text")}
      transparent={true}
      enableToastMessage={true}
      showScrollbar={false}
      skipKeyboardAware
      noPadding={modalType === "popUp"}
      webHeight={webHeight}
      style={isFromComponent && isWeb ? { overflow: "hidden" } : {}}
    >
      <View style={{ height: windowHeight * 0.9 }}>
        <PDPScreen route={pdpScreenRoute} />
      </View>
    </Modal>
  );
};

export default PDPModal;
